import { render, staticRenderFns } from "./LeftRightImage.vue?vue&type=template&id=79bcebc8&scoped=true&"
import script from "./LeftRightImage.vue?vue&type=script&lang=js&"
export * from "./LeftRightImage.vue?vue&type=script&lang=js&"
import style0 from "./LeftRightImage.vue?vue&type=style&index=0&id=79bcebc8&prod&lang=scss&scoped=true&"
import style1 from "./LeftRightImage.vue?vue&type=style&index=1&id=79bcebc8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bcebc8",
  null
  
)

export default component.exports